import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Tutorial from "@/pages/Tutorial";
import Visiting from "@/pages/Visiting";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Publications from "@/pages/Publications";
import { track } from "@/lib/track";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink p-8" data-testid="error-boundary">
          <p className="font-mono text-sm text-zinc-500">
            Something dimmed the lights. Refresh to continue.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname === "/") track("landing");
    else if (pathname === "/tutorial") track("tutorial");
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="grain bg-ink text-white antialiased">
      <BrowserRouter>
        <ErrorBoundary>
          <SmoothScroll />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/visiting" element={<Visiting />} />
          </Routes>
          <Footer />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}
